import { render, staticRenderFns } from "./AlmacenesComponent.vue?vue&type=template&id=4e286dd5&scoped=true&"
import script from "./AlmacenesComponent.vue?vue&type=script&lang=js&"
export * from "./AlmacenesComponent.vue?vue&type=script&lang=js&"
import style0 from "./AlmacenesComponent.vue?vue&type=style&index=0&id=4e286dd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e286dd5",
  null
  
)

export default component.exports